const clickTrack = (data, destinationUrl) => {
  if (!window.vmcClickTracking) {
    window.vmcClickTracking = true;
    try {
      let headers = { type: 'application/json' };
      let blob = new Blob([JSON.stringify(data)], headers);
      var beaconResult = navigator.sendBeacon('/api/search/track/click', blob);
      if(!beaconResult) {
        console.log('Failed to queue beacon to ' + destinationUrl + '\n\n' + data);
      }
    } catch(ex) {
      console.log('Unexpected error in clickTrack: ' + ex);
    } finally {
      delete window.vmcClickTracking;
    }
    window.location = destinationUrl;
  }
};

export { clickTrack };